import { ProjectDocument } from '../../../api/resources/project'
import { MainPanel } from '../../layout/main-panel/MainPanel'

interface ReportsLabelSlotProps {
  document?: ProjectDocument | null
}

export const ReportsLabelSlot = ({ document }: ReportsLabelSlotProps) => {
  return (
    <>
      {document ? (
        <>
          <MainPanel.Slot>
            <MainPanel.SlotLabel muted>{document.category}</MainPanel.SlotLabel>
          </MainPanel.Slot>
          <MainPanel.Slot>
            <MainPanel.SlotLabel>{document.name}</MainPanel.SlotLabel>
          </MainPanel.Slot>
        </>
      ) : (
        <>
          <MainPanel.Slot>
            <MainPanel.SlotLabel>No Category</MainPanel.SlotLabel>
          </MainPanel.Slot>
          <MainPanel.Slot>
            <MainPanel.SlotLabel>No document selected</MainPanel.SlotLabel>
          </MainPanel.Slot>
        </>
      )}
    </>
  )
}
